import { useMemo } from "react";

import { useLocation } from "react-router";

import AnnouncementPageId from "@mapmycustomers/shared/enum/announcements/AnnouncementPageId";

import { resolvePageIdFromPathname } from "./pageRegistry";

// The announcement page the rendered route belongs to, resolved once per pathname.
const useAnnouncementPageId = (): AnnouncementPageId | undefined => {
  const { pathname } = useLocation();
  return useMemo(() => resolvePageIdFromPathname(pathname), [pathname]);
};

export default useAnnouncementPageId;
